import React from 'react';
import type { TransferOrder } from '../transfersTypes';
import styles from './TransfersTable.module.css';

interface TransfersTableProps {
  orders: TransferOrder[];
  onAction?: (id: string, action: string) => void;
}

const statusClassMap: Record<TransferOrder['status'], string> = {
  Pending: 'statusPending',
  Dispatched: 'statusDispatched',
  Packed: 'statusPacked',
};

const actionConfig: Record<TransferOrder['status'], { label: string; className: string }> = {
  Pending: { label: 'Start Picking', className: 'actionPending' },
  Dispatched: { label: 'Confirm Receipt', className: 'actionDispatched' },
  Packed: { label: 'View Details', className: 'actionPacked' },
};

export const TransfersTable: React.FC<TransfersTableProps> = ({ orders, onAction }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Stock Transfers</h3>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>TRANSFER ID</th>
              <th className={styles.th}>FROM WAREHOUSE</th>
              <th className={styles.th}>TO WAREHOUSE</th>
              <th className={styles.th}>DATE</th>
              <th className={styles.th}>STATUS</th>
              <th className={styles.th}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => {
              const action = actionConfig[order.status];
              return (
                <tr key={order.id} className={styles.row}>
                  <td className={styles.td}>{order.transferId}</td>
                  <td className={styles.td}>{order.fromWarehouse}</td>
                  <td className={styles.td}>{order.toWarehouse}</td>
                  <td className={styles.td}>{order.date}</td>
                  <td className={styles.td}>
                    <span className={`${styles.badge} ${styles[statusClassMap[order.status]]}`}>
                      {order.status}
                    </span>
                  </td>
                  <td className={styles.td}>
                    <button
                      className={`${styles.actionButton} ${styles[action.className]}`}
                      onClick={() => onAction?.(order.id, action.label)}
                    >
                      {action.label}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
